import { useModel } from '@umijs/max';
import { Button, message } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { getWecomOAuthUrl } from '@/services/auth/wecom';
import {
  clearSensitiveAuthAttempt,
  hasRecentSensitiveAuthAttempt,
  isWeComClient,
  markSensitiveAuthAttempted,
  stashLoginRedirect,
} from '@/utils/wecom';

/**
 * 已登录但会员敏感资料不全时，在企微内提示补授权（不自动跳转，避免登录后死循环卡在登录页）。
 */
const WecomSensitiveAuthBootstrap: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const [showBanner, setShowBanner] = useState(false);
  const prompted = useRef(false);

  useEffect(() => {
    const user = initialState?.currentUser;
    if (!user?.needsSensitiveAuth || !user.wecomUserId) {
      setShowBanner(false);
      return;
    }
    if (!isWeComClient()) return;
    if (window.location.pathname.startsWith('/user/login')) return;
    if (hasRecentSensitiveAuthAttempt()) return;

    setShowBanner(true);
    if (!prompted.current) {
      prompted.current = true;
      message.info('建议授权头像/手机号，便于完善会员资料', 4);
    }
  }, [initialState?.currentUser]);

  useEffect(() => {
    if (
      initialState?.currentUser &&
      !initialState.currentUser.needsSensitiveAuth
    ) {
      clearSensitiveAuthAttempt();
      setShowBanner(false);
    }
  }, [initialState?.currentUser]);

  if (!showBanner) return null;

  return (
    <div
      style={{
        position: 'fixed',
        right: 16,
        bottom: 24,
        zIndex: 1000,
        padding: '12px 16px',
        background: 'var(--ui-bg-elevated, #fff)',
        borderRadius: 8,
        boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
        maxWidth: 280,
      }}
    >
      <div style={{ marginBottom: 8, fontSize: 13 }}>
        资料不完整：可授权企微头像/手机号
      </div>
      <Button
        type="primary"
        size="small"
        onClick={async () => {
          markSensitiveAuthAttempted();
          stashLoginRedirect(
            `${window.location.pathname}${window.location.search}${window.location.hash}`,
          );
          try {
            const redirectUri = `${window.location.origin}/user/login`;
            const res = await getWecomOAuthUrl(redirectUri);
            if (res?.data?.url) {
              window.location.href = res.data.url;
            } else {
              message.error('无法生成授权链接');
            }
          } catch {
            message.error('获取授权链接失败');
          }
        }}
      >
        去授权
      </Button>
      <Button
        type="link"
        size="small"
        onClick={() => {
          markSensitiveAuthAttempted();
          setShowBanner(false);
        }}
      >
        稍后
      </Button>
    </div>
  );
};

export default WecomSensitiveAuthBootstrap;
